import { useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { type State, store } from "@App/state";
import { setMessage } from "@App/state/action-creators";

const MAX_MESSAGE_LENGTH = 500;

function isValidMessage(decoded: string): boolean {
  return decoded.length > 0 && decoded.length <= MAX_MESSAGE_LENGTH;
}

export const useMessageParameters = () => {
  const [searchParams] = useSearchParams();
  const dispatch = useDispatch();
  const existing = useSelector((state: State) => state.orders.message);

  const messageParam = searchParams.get("message");

  useEffect(() => {
    if (!messageParam || existing) return;
    if (isValidMessage(messageParam)) {
      dispatch(setMessage(messageParam));
    }
  }, [messageParam]);

  const messageQueryParams = (): Record<string, string> => {
    const message = store.getState().orders.message;
    if (!message) return {};
    return { message };
  };

  return { messageQueryParams };
};
